<template>
  <div class="ma-1">
    <v-card flat class="pa-1">
      <v-toolbar flat color="#FFF" short>
        <v-toolbar-title
          >Atualização da Base de dados do Sistema</v-toolbar-title
        >
      </v-toolbar>
      <v-tabs centered>
        <v-tab>
          <v-icon left>mdi-apps</v-icon>
          Atualização do Sistema
        </v-tab>

        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="headers"
                :items="desserts"
                :fixed-header="true"
                :search="search"
                class="elevation-3 altura-tabela"
                show-expand
                item-key="id_arquivo"
                :single-expand="true"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Lista de Atualizações</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Pesquisar"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-toolbar>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-icon
                    title="Visualizar comandos executados"
                    @click="visualizar(item)"
                  >
                    mdi-eye
                  </v-icon>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <table style="width: 100%" class="pa-5">
                      <tr>
                        <th class="text-left">
                          <h3>
                            <v-icon class="mr-1">mdi-update</v-icon>
                            Lista de Atualizações
                          </h3>
                        </th>
                        <th class="text-left"></th>
                      </tr>
                      <tr v-for="(comando, index) in item.sql" :key="index">
                        <td class="pb-3 pt-2 border-bottom">
                          {{ comando.sql }}
                        </td>
                        <td class="pb-3 pt-2 text-align-right border-bottom">
                          <v-btn
                            v-if="!comando.executado"
                            color="blue-grey"
                            @click="save(item, comando.sql)"
                          >
                            <v-icon color="#FFF">mdi-database-import</v-icon>
                            <span style="color: #fff; padding-left: 5px"
                              >Executar</span
                            >
                          </v-btn>
                          <v-btn v-else disabled>
                            <v-icon color="#FFF">mdi-database-check</v-icon>
                            <span style="color: #fff; padding-left: 5px"
                              >Executado</span
                            >
                          </v-btn>
                        </td>
                      </tr>
                    </table>
                  </td>
                </template>
              </v-data-table>
              <v-layout>
                <v-dialog v-model="dialogErrors" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <v-btn
                        color="#000"
                        icon
                        style="margin-left: -10px"
                        @click="dialogErrors = false"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <span class="headline ml-3"
                        >Erro ao executar comando SQL</span
                      >
                    </v-card-title>
                    <v-card-text class="mt-3">
                      <p>
                        <span style="font-weight: bold"
                          >SQLSTATE error code:</span
                        >
                        {{ errors[0] }}
                      </p>
                      <p>
                        <span style="font-weight: bold"
                          >Driver specific error code:</span
                        >
                        {{ errors[1] }}
                      </p>
                      <p>
                        <span style="font-weight: bold"
                          >Driver specific error message:</span
                        >
                        {{ errors[2] }}
                      </p>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text @click="dialogErrors = false">Fechar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>
<script>
import Api from "./../../api/cfg";

export default {
  data: () => ({
    dialog: false,
    search: "",
    atualizar: 0,
    headers: [
      {
        text: "Id Arquivo",
        align: "left",
        value: "id_arquivo",
      },
      {
        text: "Versão BD",
        align: "left",
        value: "versao_bd",
      },
      {
        text: "Descrição Atualização",
        align: "left",
        value: "descricao",
      },
      { text: "", value: "data-table-expand", sortable: false },
    ],
    desserts: [],
    atualizacoes: [],
    editedItem: [],
    dialogErrors: false,
    errors: [],
  }),

  created() {
    this.initialize();
  },

  methods: {
    visualizar(item) {
      this.dialog = true;

      this.editedItem = [
        {
          id: item.id,
          id_arquivo: item.id_arquivo,
          versao_bd: item.versao_bd,
          descricao: item.descricao_atualizacao,
          sql: item.comando.split(";"),
        },
      ];
    },

    initialize() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        Api.getAtualizacoesSistema(headers)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              this.desserts = response.data.atualizacoes;
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    save(item, comando) {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        id_arquivo: item.id_arquivo,
        versao_bd: item.versao_bd,
        descricao: item.descricao,
        comando: comando,
        id_user_exec: localStorage.getItem("id"),
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        Api.addAtualizacoesSistema(headers, params).then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (!response.data.errors) {
            this.initialize();
          } else {
            this.dialogErrors = true;
            this.errors = response.data.errors;
          }
        })
      );

      this.close();
    },

    abrirDialog() {
      this.dialog = true;
      this.editedItem = this.atualizacoes;
    },

    close() {
      this.dialog = false;
    },
  },
};
</script>

<style>
.text-align-right {
  text-align: right;
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
</style>
